import { LINKS } from '@/constants/links';

export const CLARITY_PROHIBITED_ROUTES: readonly string[] = [
	LINKS().privacySettings,
	LINKS().personalInformation,
];
